import LuxuryWatch from "../../../../images/Navbar/LuxuryWatch.png";
import Diamonds from "../../../../images/Navbar/Diamonds.png";
import Jewelry from "../../../../images/Navbar/Jewelry.png";
import Gold from "../../../../images/Navbar/Gold.png";
import GoldCoins from "../../../../images/Navbar/GoldCoins.png";
import Platinum from "../../../../images/Navbar/Platinum.png";
import Silver from "../../../../images/Navbar/Silver.png";
import Bag from "../../../../images/Navbar/BagImage.png";

const links = [
  // {
  //     title: "Home",
  //     link: "/",
  //     subLinks: []
  // },
  {
    title: "What We Buy",
    link: "/what-we-buy",
    isNormalDropdown: false,
    subLinks: [
      {
        title: "Luxury Watches",
        link: "/what-we-buy/watch-buyers-nyc",
        image: LuxuryWatch.src,
      },
      {
        title: "Diamonds",
        link: "/what-we-buy/sell-diamonds-nyc",
        image: Diamonds.src,
      },
      {
        title: "Jewelry",
        link: "/what-we-buy/jewelry-buyers",
        image: Jewelry.src,
      },
      {
        title: "Gold",
        link: "/what-we-buy/gold-buyers-nyc",
        image: Gold.src,
      },
      {
        title: "Gold Coins",
        link: "/what-we-buy/gold-coin-buyers-nyc",
        image: GoldCoins.src,
      },
      {
        title: "Platinum",
        link: "/what-we-buy/platinum-buyers",
        image: Platinum.src,
      },
      {
        title: "Silver",
        link: "/what-we-buy/silver-buyers",
        image: Silver.src,
      },
      {
        title: "Bags",
        link: "/what-we-buy/designer-bag-buyers",
        image: Bag.src,
      },
    ],
  },
  {
    title: "Loans",
    link: "#",
    isNormalDropdown: true,
    subLinks: [
      {
        title: "Collateral Loans",
        link: "/collateral-loans",
        // image: LuxuryWatch.src,
      },
      {
        title: "Bridge Loans",
        link: "/bridge-loans",
        // image: LuxuryWatch.src,
      },
    ],
  },
  {
    title: "Contact Us",
    link: "/contact-us",
    isNormalDropdown: null,
    subLinks: [],
  },
  {
    title: "About Us",
    link: "/about-us",
    isNormalDropdown: null,
    subLinks: [],
  },
  {
    title: "Blogs",
    link: "/blogs",
    isNormalDropdown: null,
    subLinks: [],
  },
];

export default links;
